import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiServices from '../../services/apiServices';
 

// Async Thunks

// Fetch accounts
export const fetchAccounts = createAsyncThunk(
  'accounts/fetchAccounts',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiServices.get('accounts'); // Replace with your API endpoint
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching accounts");
    }
  },
  {
    condition: (_, { getState }) => {
      const { accountsReducer } = getState();
      if (accountsReducer?.loading || (accountsReducer?.accounts && accountsReducer.accounts.length > 0)) {
        return false;
      }
      return true;
    }
  }
);

// Add a new account
export const addAccount = createAsyncThunk(
  'accounts/addAccount',
  async (accountData, { rejectWithValue }) => {
    try {
      const response = await apiServices.post('accounts', accountData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error adding account");
    }
  }
);

// Update an account
export const updateAccount = createAsyncThunk(
  'accounts/updateAccount',
  async ({ id, accountData }, { rejectWithValue }) => {
    try {
      const response = await apiServices.put(`accounts/${id}`, accountData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error updating account");
    }
  }
);

// Delete an account
export const deleteAccount = createAsyncThunk(
  'accounts/deleteAccount',
  async (id, { rejectWithValue }) => {
    try {
      await apiServices.delete(`accounts/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error deleting account");
    }
  }
);

// Slice
const accountsSlice = createSlice({
  name: 'accounts',
  initialState: {
    accounts: [],
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Accounts
      .addCase(fetchAccounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.accounts = action.payload;
      })
      .addCase(fetchAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add Account
      .addCase(addAccount.fulfilled, (state, action) => {
        state.accounts.push(action.payload);
      })
      .addCase(addAccount.rejected, (state, action) => {
        state.error = action.payload;
      })
      // Update Account
      .addCase(updateAccount.fulfilled, (state, action) => {
        const index = state.accounts.findIndex(
          (account) => account._id === action.payload._id
        );
        if (index !== -1) {
          state.accounts[index] = action.payload;
        }
      })
      .addCase(updateAccount.rejected, (state, action) => {
        state.error = action.payload;
      })
      // Delete Account
      .addCase(deleteAccount.fulfilled, (state, action) => {
        state.accounts = state.accounts.filter(
          (account) => account._id !== action.payload
        );
      })
      .addCase(deleteAccount.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { resetError } = accountsSlice.actions;

export default accountsSlice.reducer;
